import {SetStyle} from '../set-style';
import {message} from '@common/i18n/message';

export class SetBorder extends SetStyle {
  displayName = message('Changed border style');
}
